<div class="background">
  <div class="container">
    <div>
      <img src="/assets/vectors/Congrats.svg" alt="Congrats">
    </div>
    <h1 class="title">{{'general.congratulations' | translate}}</h1>
    <div class="info">
      {{'general.welcome_text' | translate}}
    </div>
    <div class="actions">
      <button class="btn btn-primary mx-16" routerLink="/sign-in">
        {{'general.okay' | translate}}
      </button>
      <button class="btn btn-primary mx-16" (click)="sendConfirmationEmail()">
        {{'general.resend' | translate}}
      </button>
    </div>
  </div>
</div>